var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.rowClass},[(_vm.label)?_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{staticClass:"value",domProps:{"innerHTML":_vm._s(_vm.htmlValue)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }